import { defineMessages, IntlFormatters } from "react-intl";

const languageMessages = defineMessages({
    Hungarian: {
        id: "language.Hungarian",
    },
    English: {
        id: "language.English",
    },
    Czech: {
        id: "language.Czech",
    },
    Danish: {
        id: "language.Danish",
    },
    "Church Slavonic": {
        id: "language.Church Slavonic",
    },
    Finnish: {
        id: "language.Finnish",
    },
    French: {
        id: "language.French",
    },
    Greek: {
        id: "language.Greek",
    },
    Georgian: {
        id: "language.Georgian",
    },
    Hebrew: {
        id: "language.Hebrew",
    },
    Dutch: {
        id: "language.Dutch",
    },
    Croatian: {
        id: "language.Croatian",
    },
    Indonesian: {
        id: "language.Indonesian",
    },
    Irish: {
        id: "language.Irish",
    },
    Icelandic: {
        id: "language.Icelandic",
    },
    Japanese: {
        id: "language.Japanese",
    },
    Chinese: {
        id: "language.Chinese",
    },
    Latin: {
        id: "language.Latin",
    },
    Polish: {
        id: "language.Polish",
    },
    Latvian: {
        id: "language.Latvian",
    },
    Estonian: {
        id: "language.Estonian",
    },
    Lithuanian: {
        id: "language.Lithuanian",
    },
    German: {
        id: "language.German",
    },
    Norwegian: {
        id: "language.Norwegian",
    },
    Italian: {
        id: "language.Italian",
    },
    Russian: {
        id: "language.Russian",
    },
    Armenian: {
        id: "language.Armenian",
    },
    Portuguese: {
        id: "language.Portuguese",
    },
    Romanian: {
        id: "language.Romanian",
    },
    Scottish: {
        id: "language.Scottish",
    },
    Spanish: {
        id: "language.Spanish",
    },
    Swedish: {
        id: "language.Swedish",
    },
    Serbian: {
        id: "language.Serbian",
    },
    Slovak: {
        id: "language.Slovak",
    },
    Slovenian: {
        id: "language.Slovenian",
    },
    Ukrainian: {
        id: "language.Ukrainian",
    },
    Other: {
        id: "language.Other",
    },
    Catalan: {
        id: "language.Catalan",
    },
    Turkish: {
        id: "language.Turkish",
    },
});

export const opusLanguages = (fm: IntlFormatters["formatMessage"]) => {
    return [
        { value: "Hungarian", label: fm(languageMessages.Hungarian) },
        { value: "English", label: fm(languageMessages.English) },
        { value: "Czech", label: fm(languageMessages.Czech) },
        { value: "Danish", label: fm(languageMessages.Danish) },
        { value: "Church Slavonic", label: fm(languageMessages["Church Slavonic"]) },
        { value: "Finnish", label: fm(languageMessages.Finnish) },
        { value: "French", label: fm(languageMessages.French) },
        { value: "Greek", label: fm(languageMessages.Greek) },
        { value: "Georgian", label: fm(languageMessages.Georgian) },
        { value: "Hebrew", label: fm(languageMessages.Hebrew) },
        { value: "Dutch", label: fm(languageMessages.Dutch) },
        { value: "Croatian", label: fm(languageMessages.Croatian) },
        { value: "Indonesian", label: fm(languageMessages.Indonesian) },
        { value: "Irish", label: fm(languageMessages.Irish) },
        { value: "Icelandic", label: fm(languageMessages.Icelandic) },
        { value: "Japanese", label: fm(languageMessages.Japanese) },
        { value: "Chinese", label: fm(languageMessages.Chinese) },
        { value: "Latin", label: fm(languageMessages.Latin) },
        { value: "Polish", label: fm(languageMessages.Polish) },
        { value: "Latvian", label: fm(languageMessages.Latvian) },
        { value: "Estonian", label: fm(languageMessages.Estonian) },
        { value: "Lithuanian", label: fm(languageMessages.Lithuanian) },
        { value: "German", label: fm(languageMessages.German) },
        { value: "Norwegian", label: fm(languageMessages.Norwegian) },
        { value: "Italian", label: fm(languageMessages.Italian) },
        { value: "Russian", label: fm(languageMessages.Russian) },
        { value: "Armenian", label: fm(languageMessages.Armenian) },
        { value: "Portuguese", label: fm(languageMessages.Portuguese) },
        { value: "Romanian", label: fm(languageMessages.Romanian) },
        { value: "Scottish", label: fm(languageMessages.Scottish) },
        { value: "Spanish", label: fm(languageMessages.Spanish) },
        { value: "Swedish", label: fm(languageMessages.Swedish) },
        { value: "Serbian", label: fm(languageMessages.Serbian) },
        { value: "Slovak", label: fm(languageMessages.Slovak) },
        { value: "Slovenian", label: fm(languageMessages.Slovenian) },
        { value: "Ukrainian", label: fm(languageMessages.Ukrainian) },
        { value: "Catalan", label: fm(languageMessages.Catalan) },
        { value: "Turkish", label: fm(languageMessages.Turkish) },
        { value: "Other", label: fm(languageMessages.Other) },
    ].sort((a, b) => a.label.localeCompare(b.label));
};
